package org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.credit_client


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Item(
    @SerialName("clientNumber")
    val clientNumber: String?,
    @SerialName("id")
    val id: String?,
    @SerialName("name")
    val name: String?,
    @SerialName("__typename")
    val typename: String?
)